import React from 'react'
import PropTypes from 'prop-types'

import { Box } from '@resurs/midas-react'
import { getBorderType } from '../utils'
import { prettyPrintDate } from '../../../util/dateUtils'
import { getSanitizedHTML } from '../../../util/helpers'

/* eslint-disable react/no-danger */
const NewsArticle = ({ article }) => (
  <div style={{ marginBottom: '1rem' }}>
    <Box title={article.header} type={getBorderType(article.tags)}>
      <div
        style={{
          color: '#777',
          fontSize: '1.2rem',
        }}
      >
        {prettyPrintDate(article.published)}
      </div>
      <div
        style={{ paddingTop: '1.5rem', lineHeight: '2rem' }}
        dangerouslySetInnerHTML={{ __html: getSanitizedHTML(article.body) }}
      />
    </Box>
  </div>
)

NewsArticle.propTypes = {
  article: PropTypes.object.isRequired,
}

export default NewsArticle
